import { inject } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { storeToRefs } from 'pinia'

import ContactUsView from '@/views/projects/ContactUsView.vue'
import NotFoundView from '@/views/NotFoundView.vue'

import { speckleCallbackRoute } from '@haskoning/vue-speckle'
import { useAuthenticationStore } from '@/stores/authentication'
import MainView from '@/views/projects/MainView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/:pathMatch(.*)*',
      component: NotFoundView
    },
    {
      path: '/',
      name: 'home',
      component: MainView
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue')
    },
    speckleCallbackRoute,
    {
      path: '/contact-us',
      name: 'contact-us',
      component: ContactUsView
    }
  ]
})

router.beforeEach(async (to) => {
  const authStore = inject('useAuthStore')! as ReturnType<typeof useAuthenticationStore>
  const { user } = storeToRefs(authStore)

  if (!user.value) {
    await authStore.reAuthenticate()
  }
  const isAuthenticated = !!user.value

  if (to.name === 'login') {
    return isAuthenticated ? { path: (to.query.redirect as string) || '/' } : true
  }

  if (!isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }

  return true
})

export default router
